module.exports = __webpack_public_path__ + "img/ai-weapon3.b5a3e106.png";